import { normalizeDayStart, parseBackendDate } from '../../utils/dateUtils';
import { fetchFlask } from '../../utils/fetchFlask';

export const allDistributorsOption = 'all';

export const fetchTrocasMes = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('getTrocasMes', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.trocas;
};

export const fetchTrocasEmAberto = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('getTrocasEmAberto', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.unidades;
};

export const buildDistributorOptions = (trocas) => {
    const distributors = Array.from(new Set(trocas.map((troca) => troca.distribuidora)))
        .sort((left, right) => left.localeCompare(right, 'pt-BR'));

    return [
        { value: allDistributorsOption, label: 'Todas as distribuidoras' },
        ...distributors.map((distributor) => ({ value: distributor, label: distributor }))
    ];
};

export const filterTrocasByDistributor = (trocas, selectedDistributor) => {
    if (selectedDistributor === allDistributorsOption) return trocas;

    return trocas.filter((troca) => troca.distribuidora === selectedDistributor);
};

export const buildTrocasSummary = (trocas) => {
    const totalUnits = trocas.reduce((total, troca) => total + troca.entrantes, 0);
    const completed = trocas.reduce((total, troca) => total + troca.trocas_efetuadas, 0);
    const terminated = trocas.reduce((total, troca) => total + troca.distratados, 0);
    const terminatedWithoutTroca = trocas.reduce((total, troca) => total + troca.distratados_sem_troca, 0);
    const pending = trocas.reduce((total, troca) => total + troca.em_aberto, 0);

    return {
        totalUnits,
        completed,
        terminated,
        terminatedWithoutTroca,
        pending,
        completionRate: totalUnits ? completed / totalUnits : 0,
        kpi: totalUnits ? (totalUnits - pending) / totalUnits : 0
    };
};

export const buildTrocasComposition = (summary) => [
    {
        key: 'completed',
        label: 'Trocas efetuadas',
        value: summary.completed,
        color: 'var(--chart-3)'
    },
    {
        key: 'terminated',
        label: 'Distratados sem troca',
        value: summary.terminatedWithoutTroca,
        color: 'var(--ambar-escuro)'
    },
    {
        key: 'pending',
        label: 'Em aberto',
        value: summary.pending,
        color: 'var(--app-muted)'
    }
];

export const buildDistributorBreakdown = (trocas) => [...trocas]
    .sort((left, right) => right.entrantes - left.entrantes || left.distribuidora.localeCompare(right.distribuidora, 'pt-BR'));

export const buildOpenUnitRows = (unidades) => {
    const today = normalizeDayStart(new Date());

    return unidades.map((unidade) => {
        const signedAt = parseBackendDate(unidade.data_assinatura);

        return {
            ...unidade,
            diasEmAberto: signedAt ? Math.round((today - normalizeDayStart(signedAt)) / 86400000) : null
        };
    });
};
